
// // // src/context/AuthContext.jsx
// // import React, { createContext, useContext, useState, useEffect } from "react";
// // import axios from "axios";
// // import { useNavigate } from "react-router-dom";

// // const AuthContext = createContext();
// // const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5001/api";
// // let tokenGlobal = null;

// // const normalizeRole = (r) => (r ? r.trim().toLowerCase() : null);

// // export const AuthProvider = ({ children }) => {
// //   const navigate = useNavigate();

// //   const [user, setUser] = useState(() => {
// //     try {
// //       const saved = localStorage.getItem("user");
// //       return saved ? JSON.parse(saved) : null;
// //     } catch { return null; }
// //   });

// //   const [token, setToken] = useState(() => localStorage.getItem("token"));
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     const init = async () => {
// //       if (token && user) await refreshUser();
// //       setLoading(false);
// //     };
// //     init();
// //   }, []);

// //   useEffect(() => { tokenGlobal = token; }, [token]);

// //   const refreshUser = async () => {
// //     if (!token) return;
// //     try {
// //       const res = await axios.get(`${API_BASE}/auth/me`, {
// //         headers: { Authorization: `Bearer ${token}` },
// //         withCredentials: true
// //       });
// //       const backendUser = res.data?.user;
// //       if (!backendUser) return logout();

// //       const mergedUser = {
// //         ...backendUser,
// //         role: normalizeRole(backendUser.role || user?.role),
// //         grado: user?.grado || backendUser.grado || null,
// //         grupo: user?.grupo || backendUser.grupo || null,
// //         logo_url: backendUser.logo_url || user?.logo_url || null
// //       };

// //       setUser(mergedUser);
// //       localStorage.setItem("user", JSON.stringify(mergedUser));
// //     } catch {
// //       logout();
// //     }
// //   };

// //   const actualizarLogo = (logoUrl) => {
// //     if (!user) return;
// //     const updatedUser = { ...user, logo_url: logoUrl };
// //     setUser(updatedUser);
// //     localStorage.setItem("user", JSON.stringify(updatedUser));
// //   };

// //   const login = async (username, password) => {
// //     try {
// //       const res = await axios.post(`${API_BASE}/auth/login`, { username, password }, { withCredentials: true });
// //       const newToken = res.data.token;
// //       const loggedUser = { ...res.data.user, role: normalizeRole(res.data.user.role) };

// //       setToken(newToken);
// //       setUser(loggedUser);
// //       localStorage.setItem("token", newToken);
// //       localStorage.setItem("user", JSON.stringify(loggedUser));

// //       const routes = {
// //         rector: "/dashboard",
// //         administrativo: "/dashboard",
// //         profesor: "/dashboard-profesor",
// //         estudiante: "/perfil-estudiante",
// //         padre: "/perfil-padre",
// //         desarrollador: "/crear-institucion",
// //       };
// //       navigate(routes[loggedUser.role] || "/");

// //       return { ok: true, user: loggedUser };
// //     } catch (err) {
// //       let message = err.response?.data?.message || "Error de conexión";
// //       return { ok: false, message };
// //     }
// //   };

// //   const logout = async () => {
// //     try { await axios.post(`${API_BASE}/auth/logout`, {}, { withCredentials: true }); } catch {}
// //     localStorage.clear();
// //     setUser(null);
// //     setToken(null);
// //     navigate("/login");
// //   };

// //   const role = normalizeRole(user?.role);

// //   return (
// //     <AuthContext.Provider
// //       value={{
// //         user,
// //         token,
// //         login,
// //         logout,
// //         refreshUser,
// //         actualizarLogo,
// //         loading,
// //         tenant_id: user?.tenant_id || null,
// //         sede_id: user?.sede_id || null,
// //         institucion_nombre: user?.institucion_nombre || null,
// //         sede_nombre: user?.sede_nombre || null,
// //         grado: user?.grado || null,
// //         grupo: user?.grupo || null,
// //         isProfesor: () => role === "profesor",
// //         isEstudiante: () => role === "estudiante",
// //         isAdmin: () => ["rector","administrativo"].includes(role),
// //         isDev: () => role === "desarrollador"
// //       }}
// //     >
// //       {!loading && children}
// //     </AuthContext.Provider>
// //   );
// // };

// // export const useAuth = () => useContext(AuthContext);
// // export const getToken = () => tokenGlobal || localStorage.getItem("token");


// //
// // src/context/AuthContext.jsx
// // src/context/AuthContext.jsx

// // import React, { createContext, useContext, useState, useEffect } from "react";
// // import axios from "axios";
// // import axiosAuth from "../api/axiosAuth"; // 🔥 IMPORTANTE

// // const AuthContext = createContext();
// // const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5001/api";

// // let tokenGlobal = null;

// // const normalizeRole = (r) => (r ? r.trim().toLowerCase() : null);

// // export const AuthProvider = ({ children }) => {
// //   const [user, setUser] = useState(() => {
// //     try {
// //       const saved = localStorage.getItem("user");
// //       return saved ? JSON.parse(saved) : null;
// //     } catch {
// //       return null;
// //     }
// //   });

// //   const [token, setToken] = useState(() => localStorage.getItem("token"));
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     tokenGlobal = token;
// //   }, [token]);

// //   useEffect(() => {
// //     const init = async () => {
// //       if (token) {
// //         await refreshUser(); // 🔥 ahora usa interceptor automático
// //       }
// //       setLoading(false);
// //     };
// //     init();
// //   }, []);

// //   /* =========================
// //      🔄 REFRESH USER
// //   ========================= */
// //   const refreshUser = async () => {
// //     try {
// //       const res = await axiosAuth.get(`/users/me`, {
// //         withCredentials: true
// //       });

// //       const backendUser = res.data?.user || res.data;

// //       if (!backendUser) {
// //         return logout();
// //       }

// //       const normalized = {
// //         ...backendUser,
// //         role: normalizeRole(backendUser.role)
// //       };

// //       setUser(normalized);
// //       localStorage.setItem("user", JSON.stringify(normalized));

// //     } catch (err) {
// //       console.error("Error refreshUser:", err);
// //       logout();
// //     }
// //   };

// //   /* =========================
// //      🔐 LOGIN
// //   ========================= */
// //   const login = async (username, password) => {
// //     try {
// //       const res = await axios.post(
// //         `${API_BASE}/users/login`,
// //         { username, password },
// //         { withCredentials: true }
// //       );

// //       if (res.data.multiple) {
// //         return {
// //           ok: true,
// //           multiple: true,
// //           opciones: res.data.opciones
// //         };
// //       }

// //       const newToken = res.data.token;

// //       const loggedUser = {
// //         ...res.data.user,
// //         role: normalizeRole(res.data.user.role)
// //       };

// //       setToken(newToken);
// //       setUser(loggedUser);

// //       localStorage.setItem("token", newToken);
// //       localStorage.setItem("user", JSON.stringify(loggedUser));

// //       return { ok: true, user: loggedUser };

// //     } catch (err) {
// //       return {
// //         ok: false,
// //         message: err.response?.data?.message || "Error de conexión"
// //       };
// //     }
// //   };

// //   /* =========================
// //      👨‍👩‍👧 SELECCIONAR CONTEXTO PADRE
// //   ========================= */
// //   const seleccionarContextoPadre = async ({ documento, tenant_id, sede_id }) => {
// //     try {
// //       const res = await axios.post(
// //         `${API_BASE}/users/seleccionar-contexto-padre`,
// //         { documento, tenant_id, sede_id },
// //         { withCredentials: true }
// //       );

// //       const newToken = res.data.token;

// //       const loggedUser = {
// //         ...res.data.user,
// //         role: normalizeRole(res.data.user.role)
// //       };

// //       setToken(newToken);
// //       setUser(loggedUser);

// //       localStorage.setItem("token", newToken);
// //       localStorage.setItem("user", JSON.stringify(loggedUser));

// //       return { ok: true, user: loggedUser };

// //     } catch (err) {
// //       return {
// //         ok: false,
// //         message: err.response?.data?.message || "Error al seleccionar contexto"
// //       };
// //     }
// //   };

// //   /* =========================
// //      🔓 LOGOUT
// //   ========================= */
// //   const logout = async () => {
// //     try {
// //       await axios.post(`${API_BASE}/users/logout`, {}, { withCredentials: true });
// //     } catch {}

// //     localStorage.removeItem("token");
// //     localStorage.removeItem("user");

// //     setUser(null);
// //     setToken(null);

// //     window.location.href = "/login";
// //   };

// //   const role = normalizeRole(user?.role);

// //   return (
// //     <AuthContext.Provider
// //       value={{
// //         user,
// //         token,
// //         login,
// //         logout,
// //         refreshUser,
// //         seleccionarContextoPadre,
// //         loading,
// //         tenant_id: user?.tenant_id || null,
// //         sede_id: user?.sede_id || null,
// //         institucion_nombre: user?.institucion_nombre || null,
// //         sede_nombre: user?.sede_nombre || null,
// //         grado: user?.grado || null,
// //         grupo: user?.grupo || null,
// //         isProfesor: () => role === "profesor",
// //         isEstudiante: () => role === "estudiante",
// //         isPadre: () => role === "padre",
// //         isAdmin: () => ["rector", "administrativo"].includes(role)
// //       }}
// //     >
// //       {!loading && children}
// //     </AuthContext.Provider>
// //   );
// // };

// // export const useAuth = () => useContext(AuthContext);
// // export const getToken = () => tokenGlobal || localStorage.getItem("token");


// ///


// import React, { createContext, useContext, useState, useEffect } from "react";
// import axios from "axios";
// import axiosAuth from "../api/axiosAuth";

// const AuthContext = createContext();
// // const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5001/api";

// const API_BASE = process.env.REACT_APP_API_BASE || "http://3.236.217.225:5001/api";

// let tokenGlobal = null;

// const normalizeRole = (r) => (r ? r.trim().toLowerCase() : null);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(() => {
//     try {
//       const saved = localStorage.getItem("user");
//       return saved ? JSON.parse(saved) : null;
//     } catch {
//       return null;
//     }
//   });

//   const [token, setToken] = useState(() => localStorage.getItem("token"));
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     tokenGlobal = token;
//   }, [token]);

//   useEffect(() => {
//     const init = async () => {
//       if (token) {
//         await refreshUser();
//       }
//       setLoading(false);
//     };
//     init();
//   }, []);

//   /* ======================================================
//       🔄 REFRESH USER (Trae datos frescos de la DB)
//   ====================================================== */
//   const refreshUser = async () => {
//     try {
//       const res = await axiosAuth.get(`/users/me`, {
//         withCredentials: true
//       });

//       const backendUser = res.data?.user || res.data;

//       if (!backendUser) {
//         return logout();
//       }

//       const normalized = {
//         ...backendUser,
//         role: normalizeRole(backendUser.role)
//       };

//       setUser(normalized);
//       localStorage.setItem("user", JSON.stringify(normalized));

//     } catch (err) {
//       console.error("Error refreshUser:", err);
//       // Solo deslogueamos si es un error de autenticación (401/403)
//       if (err.response?.status === 401) logout();
//     }
//   };

//   /* ======================================================
//       🔐 LOGIN (Sincronizado con el backend corregido)
//   ====================================================== */
//   const login = async (username, password) => {
//     try {
//       // Nota: Cambiado a /auth/login para coincidir con app.use('/api/auth', ...)
//       const res = await axios.post(
//         `${API_BASE}/auth/login`, 
//         { username, password },
//         { withCredentials: true }
//       );

//       // Manejo de padres con múltiples hijos/contextos
//       if (res.data.requiereSeleccion) {
//         return {
//           ok: true,
//           requiereSeleccion: true,
//           contextos: res.data.contextos
//         };
//       }

//       const newToken = res.data.token;
//       const loggedUser = {
//         ...res.data.user,
//         role: normalizeRole(res.data.user.role)
//       };

//       setToken(newToken);
//       setUser(loggedUser);

//       localStorage.setItem("token", newToken);
//       localStorage.setItem("user", JSON.stringify(loggedUser));

//       return { ok: true, user: loggedUser };

//     } catch (err) {
//       return {
//         ok: false,
//         message: err.response?.data?.message || "Error de conexión"
//       };
//     }
//   };

//   /* ======================================================
//       👨‍👩‍👧 SELECCIONAR CONTEXTO PADRE
//   ====================================================== */
//   const seleccionarContextoPadre = async ({ documento, tenant_id, sede_id }) => {
//     try {
//       const res = await axios.post(
//         `${API_BASE}/auth/seleccionar-contexto-padre`,
//         { documento, tenant_id, sede_id },
//         { withCredentials: true }
//       );

//       const newToken = res.data.token;
//       const loggedUser = {
//         ...res.data.user,
//         role: normalizeRole(res.data.user.role)
//       };

//       setToken(newToken);
//       setUser(loggedUser);

//       localStorage.setItem("token", newToken);
//       localStorage.setItem("user", JSON.stringify(loggedUser));

//       return { ok: true, user: loggedUser };

//     } catch (err) {
//       return {
//         ok: false,
//         message: err.response?.data?.message || "Error al seleccionar contexto"
//       };
//     }
//   };

//   /* ======================================================
//       🔓 LOGOUT
//   ====================================================== */
//   const logout = async () => {
//     try {
//       await axios.post(`${API_BASE}/auth/logout`, {}, { withCredentials: true });
//     } catch {}

//     localStorage.removeItem("token");
//     localStorage.removeItem("user");

//     setUser(null);
//     setToken(null);

//     window.location.href = "/login";
//   };

//   const currentRole = normalizeRole(user?.role);

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         token,
//         login,
//         logout,
//         refreshUser,
//         seleccionarContextoPadre,
//         loading,
//         // Helpers de datos (Extraídos directamente del objeto user de la DB)
//         tenant_id: user?.tenant_id || null,
//         sede_id: user?.sede_id || null,
//         institucion_nombre: user?.institucion_nombre || null,
//         logo_url: user?.logo_url || null, // 🔥 Disponible globalmente
//         sede_nombre: user?.sede_nombre || null,
        
//         // Roles
//         isProfesor: () => currentRole === "profesor",
//         isEstudiante: () => currentRole === "estudiante",
//         isPadre: () => currentRole === "padre",
//         isRector: () => currentRole === "rector",
//         isAdmin: () => ["rector", "administrativo"].includes(currentRole)
//       }}
//     >
//       {!loading && children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);
// export const getToken = () => tokenGlobal || localStorage.getItem("token");


//
// import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import axiosAuth from "../api/axiosAuth";
// import { API as BASE_API } from "../components/config";

// const AuthContext = createContext();
// // const API_BASE = BASE_API || "http://3.236.217.225:5001/api";

// const API_BASE = BASE_API;

// // Para acceso fuera de componentes (ej. interceptores de axios)
// export const getToken = () => localStorage.getItem("token");

// const normalizeRole = (r) => (r ? r.toString().trim().toLowerCase() : null);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(() => {
//     try {
//       const saved = localStorage.getItem("user");
//       return saved ? JSON.parse(saved) : null;
//     } catch { return null; }
//   });

//   const [token, setToken] = useState(() => localStorage.getItem("token"));
//   const [loading, setLoading] = useState(true);

//   // ✅ logout como useCallback para poder usarlo dentro de otros useEffect sin warnings
//   const logout = useCallback(async () => {
//     try {
//       await axios.post(`${API_BASE}/auth/logout`, {}, { 
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         withCredentials: true 
//       });
//     } catch (e) {}
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     setUser(null);
//     setToken(null);
//     window.location.href = "/login";
//   }, []);

//   const refreshUser = useCallback(async () => {
//     try {
//       const res = await axiosAuth.get(`/users/me`);
//       const backendUser = res.data?.user || res.data;
//       if (!backendUser) return logout();

//       const normalized = {
//         ...backendUser,
//         role: normalizeRole(backendUser.role)
//       };
//       setUser(normalized);
//       localStorage.setItem("user", JSON.stringify(normalized));
//     } catch (err) {
//       if (err.response?.status === 401 || err.response?.status === 403) {
//         logout();
//       }
//     }
//   }, [logout]);

//   useEffect(() => {
//     const init = async () => {
//       if (token) await refreshUser();
//       setLoading(false);
//     };
//     init();
//   }, [token, refreshUser]);

//   const login = async (username, password) => {
//     try {
//       const res = await axios.post(`${API_BASE}/auth/login`, { username, password }, { withCredentials: true });
//       if (res.data.requiereSeleccion) return { ok: true, requiereSeleccion: true, contextos: res.data.contextos };

//       const newToken = res.data.token;
//       const loggedUser = { ...res.data.user, role: normalizeRole(res.data.user.role) };

//       setToken(newToken);
//       setUser(loggedUser);
//       localStorage.setItem("token", newToken);
//       localStorage.setItem("user", JSON.stringify(loggedUser));
//       return { ok: true, user: loggedUser };
//     } catch (err) {
//       return { ok: false, message: err.response?.data?.message || "Error de conexión" };
//     }
//   };

//   const seleccionarContextoPadre = async (data) => {
//     try {
//       const res = await axios.post(`${API_BASE}/auth/seleccionar-contexto-padre`, data, { withCredentials: true });
//       const newToken = res.data.token;
//       const loggedUser = { ...res.data.user, role: normalizeRole(res.data.user.role) };

//       setToken(newToken);
//       setUser(loggedUser);
//       localStorage.setItem("token", newToken);
//       localStorage.setItem("user", JSON.stringify(loggedUser));
//       return { ok: true, user: loggedUser };
//     } catch (err) {
//       return { ok: false, message: err.response?.data?.message || "Error al seleccionar" };
//     }
//   };

//   const currentRole = normalizeRole(user?.role);

// return (
//   <AuthContext.Provider
//     value={{
//       user,
//       token,
//       login,
//       logout,
//       refreshUser,
//       seleccionarContextoPadre,
//       loading,
//       tenant_id: user?.tenant_id || user?.institucion_id || null,
//       sede_id: user?.sede_id || null,
//       role: currentRole,

//       isProfesor: () => currentRole === "profesor",
//       isEstudiante: () => currentRole === "estudiante",
//       isPadre: () => currentRole === "padre",
//       isRector: () => currentRole === "rector",
//       isAdmin: () => ["rector", "coordinador", "administrativo"].includes(currentRole),

//       // 🔥 AÑADIR ESTO:
//       isDev: () => currentRole === "desarrollador"
//     }}
//   >
//     {!loading && children}
//   </AuthContext.Provider>
// );
// };

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) throw new Error("useAuth debe usarse dentro de un AuthProvider");
//   return context;
// };

//
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import axios from "axios";
import axiosAuth from "../api/axiosAuth";
import { API as BASE_API } from "../components/config";

const AuthContext = createContext();
const API_BASE = BASE_API;

export const getToken = () => localStorage.getItem("token");

const normalizeRole = (r) => (r ? r.toString().trim().toLowerCase() : null);

/* =========================================================
   🧠 NORMALIZADOR MAESTRO DEL USUARIO
========================================================= */
const normalizeUser = (backendUser = {}) => {
  const fotoFinal =
    backendUser.foto ||
    backendUser.foto_perfil ||
    backendUser.avatar ||
    null;

  return {
    ...backendUser,

    role: normalizeRole(backendUser.role),

    nombre:
      backendUser.nombre ||
      backendUser.nombres ||
      backendUser.nombres_estudiante ||
      "",

    apellido:
      backendUser.apellido ||
      backendUser.apellidos ||
      backendUser.apellidos_estudiante ||
      "",

    nombreCompleto: `${
      backendUser.nombre ||
      backendUser.nombres ||
      backendUser.nombres_estudiante ||
      ""
    } ${
      backendUser.apellido ||
      backendUser.apellidos ||
      backendUser.apellidos_estudiante ||
      ""
    }`.trim(),

    foto: fotoFinal,

    logo_url: backendUser.logo_url || backendUser.logo || null,

    tenant_id: backendUser.tenant_id || backendUser.institucion_id || null,

    sede_id: backendUser.sede_id || null,
  };
};

/* =========================================================
   🚀 PROVIDER
========================================================= */
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem("user");
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });

  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  /* ================= LOGOUT ================= */
  const logout = useCallback(async () => {
    try {
      await axiosAuth.post("/auth/logout");
    } catch (e) {
      console.warn("logout backend omitido");
    }

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    setUser(null);
    setToken(null);

    window.location.href = "/login";
  }, []);

  /* ================= REFRESH USER DESDE /AUTH/ME ================= */
  const refreshUser = useCallback(async () => {
    try {
      const res = await axiosAuth.get("/auth/me");
      const backendUser = res.data?.user || res.data;

      if (!backendUser) {
        return logout();
      }

      const normalized = normalizeUser(backendUser);

      console.log("👤 USER REFRESCADO:", normalized);

      setUser(normalized);
      localStorage.setItem("user", JSON.stringify(normalized));

      return normalized;
    } catch (err) {
      console.error("❌ refreshUser error:", err?.response?.data || err.message);

      if (err.response?.status === 401 || err.response?.status === 403) {
        logout();
      }
    }
  }, [logout]);

  /* ================= INIT SESSION ================= */
  useEffect(() => {
    const init = async () => {
      try {
        if (token) {
          await refreshUser();
        }
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [token, refreshUser]);

  /* ================= LOGIN ================= */
  const login = async (username, password) => {
    try {
      const res = await axios.post(
        `${API_BASE}/auth/login`,
        { username, password },
        { withCredentials: true }
      );

      if (res.data.requiereSeleccion) {
        return {
          ok: true,
          requiereSeleccion: true,
          contextos: res.data.contextos,
        };
      }

      const newToken = res.data.token;
      const loggedUser = normalizeUser(res.data.user);

      console.log("✅ LOGIN USER:", loggedUser);

      setToken(newToken);
      setUser(loggedUser);

      localStorage.setItem("token", newToken);
      localStorage.setItem("user", JSON.stringify(loggedUser));

      return { ok: true, user: loggedUser };
    } catch (err) {
      return {
        ok: false,
        message: err.response?.data?.message || "Error de conexión",
      };
    }
  };

  /* ================= PADRE MULTICONTEXTO ================= */
  const seleccionarContextoPadre = async (data) => {
    try {
      const res = await axios.post(
        `${API_BASE}/auth/seleccionar-contexto-padre`,
        data,
        { withCredentials: true }
      );

      const newToken = res.data.token;
      const loggedUser = normalizeUser(res.data.user);

      setToken(newToken);
      setUser(loggedUser);

      localStorage.setItem("token", newToken);
      localStorage.setItem("user", JSON.stringify(loggedUser));

      return { ok: true, user: loggedUser };
    } catch (err) {
      return {
        ok: false,
        message: err.response?.data?.message || "Error al seleccionar",
      };
    }
  };

  const currentRole = normalizeRole(user?.role);

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        login,
        logout,
        refreshUser,
        seleccionarContextoPadre,
        loading,

        tenant_id: user?.tenant_id || null,
        sede_id: user?.sede_id || null,
        role: currentRole,

        isProfesor: () => currentRole === "profesor",
        isEstudiante: () => currentRole === "estudiante",
        isPadre: () => currentRole === "padre",
        isRector: () => currentRole === "rector",
        isAdmin: () =>
          ["rector", "coordinador", "administrativo"].includes(currentRole),
        isDev: () => currentRole === "desarrollador",
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

/* =========================================================
   HOOK
========================================================= */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth debe usarse dentro de un AuthProvider");
  }

  return context;
};
